module.exports = __webpack_public_path__ + "img/IMG_2493_L_WoodMatted_MockedUp.eca3e5d0.jpg";